import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

const baseEventParams = {
  page: '/deceso/exito',
  page_title: 'Deceso - Exito',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const pageViewDataLayer = (plan: DataLayerPlanType, insured: string, withAgent: boolean) => ({
  ...baseEventParams,
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

const discoverMoreDataLayer = (plan: DataLayerPlanType, insured: string, cardTitle: string) => ({
  ...baseEventParams,
  action_type: 'click',
  action: `Click - Descubre mas ${cardTitle}`,
  product_type: plan,
  asegurados: insured,
});

export const successPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: pageViewDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), withAgent),
  });

export const successDiscoverMoreClick = (planCode: string, insured: number, cardTitle: string) =>
  BaseDataLayer({
    eventParams: discoverMoreDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), cardTitle),
  });
